import { i18n } from '../../../../internationalize/i18n.service'
import { ChartRouterComponent } from '../../..';
import styleCSS from "./chart-tabs.style.scss?inline"

export class ChartTabsComponent extends HTMLElement {
    private _shadowRoot: ShadowRoot;
    private _chartContainer!: HTMLDivElement;
    private _chartIds!: string[];
    private _chartTypes!: string[];
    private _tabsContainer!: HTMLDivElement;
    private _initialized = false;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
    }

    connectedCallback() {
        const style = document.createElement('style');
        style.textContent = styleCSS;
        this._shadowRoot.appendChild(style);
        this.init();
    }

    init() {
        if (this._initialized) return;
        this._chartIds = this.getAttribute('ids')?.split(',').filter(Boolean) || [];
        this._chartTypes = this.getAttribute('types')?.split(',').filter(Boolean) || [];
        if (this._chartIds.length !== this._chartTypes.length) {
            console.warn('ChartTabs: ids and types length mismatch');
            this._chartTypes = this._chartTypes.slice(0, this._chartIds.length);
        }
        this._initialized = true;
        this.setGUI()
    }

    setGUI() {
        this._tabsContainer = document.createElement('div') as HTMLDivElement
        this._tabsContainer.classList.add('tabs-wrapper')
        this.createTabs(this._tabsContainer)
        this._shadowRoot.appendChild(this._tabsContainer)
        this._chartContainer = document.createElement('div') as HTMLDivElement
        this._chartContainer.classList.add('chart-container')
        this._shadowRoot.appendChild(this._chartContainer)

        this.createChart(this._chartIds[0], this._chartContainer, this._chartTypes[0])
        const firstTab = this._tabsContainer.querySelector('button') as HTMLButtonElement
        if (firstTab) {
            firstTab.classList.add('active')
            firstTab.setAttribute('aria-selected', 'true')
        }
    }

    private createTabs(container: HTMLDivElement) {
        container.setAttribute('role', 'tablist')
        this._chartIds.forEach((t: string) => {
            const tab = document.createElement('button')
            tab.setAttribute('chart-type', t)
            tab.setAttribute('role', 'tab')
            tab.innerHTML = `
            <p class="tab-button-text">${i18n.t(t)}</p>
            `
            tab.classList.add('tab-button')
            tab.addEventListener('click', () => {
                this.onClickTab(tab)
                window.tbwServices.analyticsService.track("dashboard_tab_click")
            })
            container.appendChild(tab)
        })
    }

    private onClickTab(tab: HTMLButtonElement) {
        if (tab.classList.contains('active')) {
            return;
        }

        this._chartContainer.innerHTML = ''
        this._tabsContainer.querySelectorAll('button').forEach((t: HTMLButtonElement) => {
            t.classList.remove('active')
            t.setAttribute('aria-selected', 'false')
        })
        tab.classList.add('active')
        tab.setAttribute('aria-selected', 'true')

        const chartTypeIndex = this._chartIds.indexOf(tab.getAttribute('chart-type') || '')
        this.createChart(tab.getAttribute('chart-type') || '', this._chartContainer, this._chartTypes[chartTypeIndex])
    }

    private createChart(id: string, container: HTMLDivElement, type: string) {
        const chart = new ChartRouterComponent();
        chart.setAttribute('chart-type', id);
        chart.setAttribute('series-type', type || 'Stacked Area');
        container.appendChild(chart);
    }
}
